import React, { Component } from 'react';

class About extends Component {
  render() {
    return(
      <div className="about-text">
      <h1 style={{textAlign: 'center', fontSize: '360%'}}>About Page</h1>
      <hr/>
      <div>
      <p>Hey there! I'm a recent Computer Science graduate from UC Santa Cruz and community member of San Jose. I am highly interested in new technologies and learning about the latest advancements in computer science. </p>
      <p>My passion lies in the field of software engineering and technology management. As an aspiring software developer, my goal is to pursue opportunities in these fields.</p>
      <div className="about-text">
      <i>"The important thing is not to stop questioning. Curiosity has its own reason for existence. One cannot help but be in awe when he contemplates the mysteries of eternity, of life, of the marvelous structure of reality. It is enough if one tries merely to comprehend a little of this mystery each day." — Albert Einstein</i>
      <div>
      <p></p>
      </div>
      </div>
      </div>
      </div>
    )
  }
}

export default About;
